
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWiperFluid as ObiWiperFluidElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wiper-fluid.js';
 
 
 

 
 export const ObiWiperFluid = createComponent({
   react: React,
   tagName: 'obi-wiper-fluid',
   elementClass: ObiWiperFluidElement,
   events: {
     
   }
  });
 
 